import {
  _CommonPublicationsSubscriptions,
  PUBLISHER_USER_ID,
  SHARED_OBJECT_TYPE_UI_TO_SERVER,
} from "./_CommonPublicationsSubscriptions";
import { endpoints } from "./endpoints";
import { httpAll } from "./utils/httpAll";

export class Publications extends _CommonPublicationsSubscriptions {
  endPointRoot = process.env.REACT_APP_ROOT_T_REST;

  /**
   * Retrieves publications
   *
   * @param {object} params - request parameters
   * @param {string} params.type - type of publications to retrieve. One
   *      of: "list", "ranking", "strategy" or "systematicPortfolio".
   *
   *      If params.type is not specified, all available publications
   *      are retrieved
   *
   * @returns {Promise} a promise fulfilled with the
   *       handled data of the response
   */
  async get({
    type,
  }: {
    type?: keyof typeof SHARED_OBJECT_TYPE_UI_TO_SERVER;
  } = {}) {
    const url = this.endPointRoot + endpoints.pubSub.publications.get;

    // used and set by app-support
    // const isAdminMode = this.environment.isAdminMode ? true : false;

    const publisherUserId = PUBLISHER_USER_ID;
    const publicationsType = SHARED_OBJECT_TYPE_UI_TO_SERVER;
    // const userId = this.environment.account.user?.id;

    if (type != null && type in publicationsType) {
      //   if (userId === publisherUserId && isAdminMode === false) {
      //     return Promise.resolve([]);
      //   }

      const paramsType = {
        objectType: publicationsType[type],
        ownerId: publisherUserId,
      };

      const response = await this.prepareGet(url, paramsType, null);
      const decodedResponse = this.decode(response);
      return this.getDetails("publications", decodedResponse);
    }

    // if (userId === publisherUserId && isAdminMode === false) {
    //   const empty = {
    //     lists: [],
    //     rankings: [],
    //     strategies: [],
    //     systematicPortfolios: [],
    //   };

    //   return Promise.resolve(empty);
    // }

    const paramsTypeLists = {
      objectType: publicationsType.list,
      ownerId: publisherUserId,
    };

    const paramsTypeRankings = {
      objectType: publicationsType.ranking,
      ownerId: publisherUserId,
    };

    const paramsTypeStrategies = {
      objectType: publicationsType.strategy,
      ownerId: publisherUserId,
    };

    const paramsTypeSystematicPortfolios = {
      objectType: publicationsType.systematicPortfolio,
      ownerId: publisherUserId,
    };

    const paramsTypeCombinedStrategies = {
      objectType: publicationsType.combinedStrategy,
      ownerId: publisherUserId,
    };

    const paramsTypeCombinedProducts = {
      objectType: publicationsType.combinedProduct,
      ownerId: publisherUserId,
    };

    const response = await httpAll({
      lists: this.prepareGet(url, paramsTypeLists, null),
      rankings: this.prepareGet(url, paramsTypeRankings, null),
      strategies: this.prepareGet(url, paramsTypeStrategies, null),
      systematicPortfolios: this.prepareGet(
        url,
        paramsTypeSystematicPortfolios,
        null
      ),
      combinedStrategies: this.prepareGet(
        url,
        paramsTypeCombinedStrategies,
        null
      ),
      combinedProducts: this.prepareGet(url, paramsTypeCombinedProducts, null),
    });

    const decodedResponse = this.decodeAll(response);
    return this.getDetailsAll("publications", decodedResponse);
  }
  async getSubscriptions(params: any) {
    let _requests: any = {};
    params.objectsType.forEach((objectType: string) => {
      _requests[objectType] = this.prepareGet(
        this.endPointRoot + endpoints.pubSub.subscriptions.get,
        {
          objectType: this._getSharedObjectServerType(objectType),
          userId: params["accountId"],
        },
        null
      );
    });

    return httpAll(_requests).then((response) => {
      var subscribed: any = {};
      var data = null;
      for (var type in response) {
        data = response[type]["data"];
        subscribed[type] = [];
        for (var i = 0, length = data.length; i < length; i++) {
          subscribed[type].push(data[i]["objectId"]);
        }
      }
      return subscribed;
    });
  }
  _getSharedObjectServerType = (type: any) => {
    switch (type) {
      case "basket":
      case "list":
      case "portfolio": {
        return "COLLECTION";
      }
      case "ranking": {
        return "RANKING_ABOUT_TARGET";
      }
      case "strategy": {
        return "PREFERENCE_INDEX";
      }
      case "systematicPortfolio": {
        return "SYSTEMATIC_PRODUCT";
      }
      default: {
        return null;
      }
    }
  };
  async subscribe({
    objectId,
    userId,
    type,
  }: {
    objectId: number;
    userId: number;
    type: keyof typeof SHARED_OBJECT_TYPE_UI_TO_SERVER;
  }) {
    const url = this.endPointRoot + endpoints.pubSub.subscriptions.create;
    const objectType = SHARED_OBJECT_TYPE_UI_TO_SERVER[type];
    const paramsCreate = {
      objectId: objectId,
      objectType: objectType,
      userId: userId,
    };
    return this.preparePost(url, paramsCreate, null);
  }
}
